// common values shared between UI and tests
export const dataHooks = {
  selectorList: 'modal-selector-layout-list',
};
